import * as R from "ramda";
import { call, reducer } from "../../helpers/api/meta";
import { proctorDetail } from "../../helpers/api/api";

export const GET_PROCTOR_DETAIL = "GET_PROCTOR_DETAIL";

export const getProctorDetail = (id) => {
  const meta = {
    endpoint: () => proctorDetail(id),
    action: GET_PROCTOR_DETAIL,
    messages: {
      id: "getProctorDetail",
      failure: "Could not get proctor detail",
    },
  };
  return call(meta);
};

const initialState = {
  loading: false,
  proctors: [],
};

const saveProctorDetail = (state, action) => {
  return R.assoc("proctors", action, state);
};

const messages = {
  loadFailed: "Could not load proctor detfail.",
};

export default reducer(
  initialState,
  GET_PROCTOR_DETAIL,
  saveProctorDetail,
  messages.loadFailed
);
